import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../lib/net";
import Dt_Txt from "../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

import sso from "../sso.js";

class CCS_Day extends React.Component {

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.eka = [];

        this.state.tot = {};
        this.state.tot.netto = "";
        this.state.tot.brutto = "";
        this.state.tot.resultat = "";

        this.state.today = new Date();
        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;
    }

    componentDidMount(){
        this.st_oms();
    }

    componentWillUnmount(){
    }

    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        css.overflow = "auto";
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }

    st_oms() {
        var self = this;
    
        self.setState({ eka: [] });

        var sdo = {};
        sdo.eko = {};
        //var fdat = format(this.state.fdat, "yyyy-MM-dd");
        //var tdat = format(this.state.tdat, "yyyy-MM-dd");
        var fdat = this.state.dts;
        var tdat = this.state.dts;
    
        var reqfkn = "pos.pos_eko.st_oms";
        if(this.state.tdts != this.state.dts) reqfkn = "pos.pos_eko.sth_oms";

        //var csa = self.get_csa();
        var csa = sso.sdo.csa;

          function send_req(cso) {
              const promise1 = new Promise((resolve, reject) => {
                  //setTimeout(resolve, 500, 'one');
                  var prm = {};
                  prm.sid = cso.c0sid;
                  prm.req = reqfkn;
                  prm.avd = cso.c0avd;
                  if(cso.c0dpa) prm.dpa = JSON.stringify(cso.c0dpa);
                  prm.fdat = fdat;
                  prm.tdat = tdat;
                  //alert(JSON.stringify(prm));
    
                  net.sid_req(prm)
                  .then(function(ret){
                      //alert(JSON.stringify(ret.ok));
                      //alert(JSON.stringify(ret.rco.tot));
                      //sdo.eko[sid] = ret.rco;
                      //alert(JSON.stringify(cso.c0sid));
                      //alert(JSON.stringify(ret.rco.tot));
                      if(!ret.rco.tot) resolve();
                      //if(!ret.rco) ret.rco = {};
                      //if(!ret.rco.tot) ret.rco.tot = {};
                      //alert(JSON.stringify(ret.rco.tot));
                      sdo.eko[cso.c0sid] = {};
                      sdo.eko[cso.c0sid].lopnr = cso.c0lopnr;
                      sdo.eko[cso.c0sid].text = cso.c0text;
                      sdo.eko[cso.c0sid].tot = ret.rco.tot;
                      //alert(JSON.stringify(sdo.eko[cso.c0sid]));
                      resolve();
                  })
                  .catch(function(e){
                      var txt = JSON.stringify(e);
                  });
              });
            return promise1;
          }
          var qa = [];
          for(var so of csa) {
              var promise = send_req(so);
              qa.push(promise);
          }

        Promise.all(qa)
        .then(function(ret){
            //alert(JSON.stringify(ret));
            //var eka = Object.values(sdo.eko);
            var tot = {};
            tot.netto = 0;
            tot.brutto = 0;
            tot.resultat = 0;
            var eka = [];
            var keys = Object.keys(sdo.eko);
            //alert(JSON.stringify(keys));
            keys.sort();
            for(var key of keys) {
                var o = sdo.eko[key];
                tot.netto = tot.netto + (o.tot.netto * 1);
                tot.brutto = tot.brutto + (o.tot.brutto * 1);
                tot.resultat = tot.resultat + (o.tot.resultat * 1);
                eka.push(o);
            }
            //alert(JSON.stringify(eka));
            self.setState({sdo: sdo, eka: eka, tot: tot });
    /*
            var sdo = ret.rco;
            var a = [];
            var keys = Object.keys(sdo.dto);
            for(var key of keys) {
                var o = sdo.dto[key];
                a.push( o );
            }
            a.push( sdo.tot );
            //self.setState({dto: dto, eka: a }, () => self.line_chart());
            self.setState({sdo: sdo, eka: a });
     */
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
      }
    
    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">


            <div className="d-flex flex-row justify-content-between">
                <div className="">OMSATT DAG</div>
            </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="cdiblue" onClick={() => this.st_oms() }>UPPDATERA</div>
                </div>
                <div className="flex">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                        <th>Avdelning</th>
                        <th>Netto</th>
                        <th>Brutto</th>
                        <th>Resultat</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.eka.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.row_open(row) }>
                        <td>{ row.text.toswe() }</td>
                        <td className="text-right">{ row.tot.netto.cdipris() }</td>
                        <td className="text-right">{ row.tot.brutto.cdipris() }</td>
                        <td className="text-right">{ row.tot.resultat.cdipris() }</td>
                    </tr>
                    )}
                    <tr>
                        <th>Summa</th>
                        <th className="text-right">{ this.state.tot.netto.cdipris() }</th>
                        <th className="text-right">{ this.state.tot.brutto.cdipris() }</th>
                        <th className="text-right">{ this.state.tot.resultat.cdipris() }</th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="">
                <div className="txt_14">Avdelningar : { this.state.eka.length }</div>
            </div>

         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default CCS_Day;
